import React from 'react';

import EcalPlan from './ecalPlan';
import ConnectPlanCard from './connectPlan';

function Billing (props) {
    return (
        <React.Fragment>
            <EcalPlan {...props} />
            <ConnectPlanCard />
        </React.Fragment>
    );
}

export default Billing;
